export default "__VITE_ASSET__9cd5bfa8__"